import React from "react";

export default function RepeatIcon({
                                       width = 50,
                                       height = 50,
                                       fill = "#ff4500",
                                   }) {
    return (
        <>
            <svg
                width={width}
                height={height}
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="Icons"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g id="Rounded" transform="translate(-102.000000, -4144.000000)">
                        <g id="Social" transform="translate(100.000000, 4044.000000)">
                            <g
                                id="-Round-/-Social-/-sentiment_dissatisfied"
                                transform="translate(0.000000, 98.000000)"
                            >
                                <g>
                                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                    <path
                                        d="M15.5,11 C14.6715729,11 14,10.3284271 14,9.5 C14,8.67157288 14.6715729,8 15.5,8 C16.3284271,8 17,8.67157288 17,9.5 C17,10.3284271 16.3284271,11 15.5,11 Z M8.5,11 C7.67157288,11 7,10.3284271 7,9.5 C7,8.67157288 7.67157288,8 8.5,8 C9.32842712,8 10,8.67157288 10,9.5 C10,10.3284271 9.32842712,11 8.5,11 Z M11.99,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 11.99,22 C6.47,22 2,17.52 2,12 C2,6.48 6.47,2 11.99,2 Z M12,20 C16.42,20 20,16.42 20,12 C20,7.58 16.42,4 12,4 C7.58,4 4,7.58 4,12 C4,16.42 7.58,20 12,20 Z M12,14 C13.9,14 15.63,14.96 16.66,16.58 C16.88,16.93 16.77,17.39 16.42,17.61 C16.29,17.68 16.16,17.72 16.02,17.72 C15.77,17.72 15.52,17.6 15.38,17.37 C14.64,16.19 13.38,15.49 12,15.49 C10.62,15.49 9.36,16.19 8.62,17.37 C8.4,17.72 7.94,17.83 7.59,17.61 C7.24,17.39 7.13,16.93 7.35,16.58 C8.37,14.97 10.1,14 12,14 Z"
                                        id="🔹-Icon-Color"
                                        fill={fill}
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </>
    );
}
